export type MascotMood = "idle" | "correct" | "perfect" | "wrong" | "hint" | "nervous" | "again" | "hard" | "good" | "easy" | "thinking";

export type MascotSize = "xs" | "sm" | "md" | "lg";

export interface MascotProps {
    mood: MascotMood;
    size?: MascotSize;
    className?: string;
    ariaLabel?: string;
    /** Show the speech bubble with the mood message. Defaults to false. */
    showBubble?: boolean;
    /** Override the default mood message in the speech bubble. */
    message?: string;
}

export const MASCOT_SIZE_PX: Record<MascotSize, number> = {
    xs: 32,
    sm: 64,
    md: 96,
    lg: 160,
};

export const MASCOT_PULSE_MS: Record<Exclude<MascotMood, "idle" | "nervous" | "thinking">, number> = {
    correct: 1500,
    perfect: 2500,
    wrong: 2000,
    hint: 1800,
    again: 2000,
    hard: 2000,
    good: 1500,
    easy: 2500,
};

export const MASCOT_ARIA_LABEL: Record<MascotMood, string> = {
    idle: "Lydi is feeling happy — ready to practise speaking",
    correct: "Lydi is excited — that's exactly right, great job!",
    perfect: "Lydi is celebrating a perfect score",
    wrong: "Lydi is feeling sad — not quite, but every mistake helps you grow",
    hint: "Lydi winks — try saying it out loud first",
    nervous: "Lydi is nervous — time is running low, you can do it!",
    again: "Lydi is a little sad — don't worry, you'll get it next time!",
    hard: "Lydi is nervous — that was a tough one, keep going!",
    good: "Lydi is happy — you're doing great!",
    easy: "Lydi is celebrating — you're on fire!",
    thinking: "Lydi is thinking — processing your request",
};

/** Mood messages shown in the speech bubble (when `showBubble` is enabled). */
export const MASCOT_MESSAGE: Record<MascotMood, string> = {
    idle: "Hi! I'm Lydi — ready to practise speaking?",
    correct: "Yes! That's exactly right — great job!",
    perfect: "PERFECT score! You're absolutely on fire today! 🔥",
    wrong: "Not quite — but every mistake helps you grow!",
    hint: "Psst — try saying it out loud first! 😉",
    nervous: "Only a few seconds left — you can do it, go!",
    again: "No worries at all — let's try again until it sticks!",
    hard: "That one was tricky — take your time, you've got this!",
    good: "Nice work — you're making great progress!",
    easy: "Wow — you nailed that one! Keep the streak going! ✨",
    thinking: "Let me think about that...",
};